// extracted by mini-css-extract-plugin
export var button = "_dt-4";
export var hasDarkBackground = "_dt-7";
export var hasLightBackground = "_dt-6";
export var iconWrapper = "_dt-0";
export var large = "_dt-2";
export var medium = "_dt-1";
export var small = "_dt-5";
export var xsmall = "_dt-3";